import type { TourDef } from '../types'
import { demoTour } from './demo.tour'

/**
 * Every tour shipped with this build. Add a tour by importing its `<id>.tour.ts` here. The Help
 * menu's "Guided tours" entry stays disabled while none of these is available to the user.
 *
 * The dev demo tour (#999) is listed only in a dev build: `import.meta.env.DEV` is `false` in
 * `vite build`, so the demo is dropped from the prod bundle.
 */
export const TOUR_DEFS: TourDef[] = import.meta.env.DEV ? [demoTour] : []
